import { TranslationKeys } from '~frontend-common/i18n/english/core.i18n';

const keys: TranslationKeys = {
  core: {
    products: {
      insurance: 'Assurance',
      name: {
        car: 'auto',
        home: {
          condo: 'condo',
          tenant: 'locataire',
          homeowner: 'maison',
        },
      },
      type: {
        car: 'automobile',
        home: 'habitation',
      },
    },
    components: {
      expandableDropdown: {
        dialog: {
          title: 'Sélectionnez votre choix',
          searchPlaceHolderText: 'Rechercher une réponse',
          noOptionFound: 'Aucune option trouvée',
        },
      },
      loadMoreResults: {
        loadMore: 'Afficher plus de résultats',
        maxRows: "Maximum d'items atteint. Pour obtenir plus de résultats, contactez l'équipe de produit.",
        fullyLoaded: 'Aucun autre résultat à afficher',
      },
    },
  },
  incognito: {
    description: "S'il vous plaît activez les cookies de votre fureteur web.",
    title: 'Nous avons besoin de cookies pour fonctionner correctement',
  },
  languages: {
    en: 'english',
    fr: 'français',
  },
  measurementSystem: {
    imperial: 'pi',
    metric: 'm',
  },
  notSupported: {
    description:
      "Malheureusement, votre navigateur n'est actuellement pas supporté. Vous pouvez utiliser Google Chrome, Safari, Microsoft Edge ou Firefox pour accéder à toutes nos fonctionnalités.",
    title: 'Navigateur non supporté',
  },
  numeric: {
    1: 'un',
    2: 'deux',
    3: 'trois',
    4: 'quatre',
    5: 'cinq',
    6: 'six',
    7: 'sept',
    8: 'huit',
    9: 'neuf',
  },
  underMaintenance: {
    description: 'Désolé, le site est actuellement en maintenance. Nous serons de retour très bientôt.',
    title: 'Maintenance',
  },
  unknownError: {
    headline: 'Erreur!',
    title: "Une erreur inconnue s'est produite.",
    subtitle: 'Avez-vous une idée de ce qui vient de se passer?',
  },
};

export default keys;
